<template>
  <div>
    <a-select
      :disabled="disabled"
      :multiple="false"
      :placeholder="placeholder"
      :value="value"
      :class="class"
      allow-clear
      option-filter-prop="title"
      show-search
      @change="onChange"
    >
      <a-select-option
        v-for="item in records?.records"
        :key="item.takeOutId"
        :title="item.takeOutBizNo"
        :value="item.takeOutId"
      >
        {{ item.takeOutBizNo }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script lang="ts">
import _ from "lodash";
import { defineComponent, onActivated, onMounted, watch } from "vue";
import { ExWarehouseService } from "./service";
import { useRoute } from "vue-router";

/**
 * 合同选择器
 *
 * 使用方式:
 * <contract-select v-model:value="formRef.contractId"></contract-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "RequisitionSelect",
  props: {
    externalData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    value: {
      type: String,
      default: undefined,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: "请选择",
    },

    projectId: {
      type: String,
      default: undefined,
    },
    name: {
      type: String,
      default: undefined,
    },

    class: {
      type: String,
      default: "append-to-body",
    },
    flowStatus: {
      type: Array,
      default: () => [],
    },
    validStatus: {
      type: String,
      default: "ysx",
    },
  },
  emits: ["update:value", "selectChange", "changetype"],
  setup(props, { emit }) {
    // const { data: records, run, loading } = ExWarehouseService.useExWarehouseListApi();
    const { data: records, run, loading } = ExWarehouseService.useExWarehouseList();
    const route = useRoute();
    const onChange = async (id, option) => {
      //@ts-ignore
      let current = records.value.records.find((o) => o.takeOutId == id);
      // console.log(current, "~~~~~~~", id);
      emit("update:value", id);
      emit("selectChange", current);
    };

    const search = async (id?) => {
      const req = {
        firstDisplayProjectId:route['query']['projectId']?route['query']['projectId']:null,
      };
      await run(req);
      // console.log(records.value, "records~~~~~~~~");
    };
    onMounted(() => {
      search();
    });
    onActivated(async () => {
      await search();
    });
    // watch(
    //   () => props.projectId,
    //   async (n) => {
    //     if(n){
    //       await search(n);
    //     }else{
    //       records.value={records:[]}
    //     }
    //     // console.log("🚀 ~ file: index.vue:89 ~ n:", n,records)

    //   },
    //   { immediate: true }
    // );

    // 修改项目时, 重新获取项目下的合同
    // watch(
    //   () => props.value,
    //   async (newValue) => {
    //     if (newValue) {
    //       await search();
    //     }
    //   },
    //   { immediate: true }
    // );

    return {
      records,
      loading,
      onChange,
    };
  },
});
</script>
